import actions from '../../actionTypes';

export default () => {
  return {
    type: actions.UPDATE_TAGS_TIME
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/updateTagsTime.js